<template>
  <div class="schoolChoose" :class="{ inApp: $root.$data.isApp || isMiniProgram}">
    <common-title titleName="智能规划" :isAPPShow="true" :bcColor="'#F7F8FC'" :zIndex="100" />
    <div class="submit">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/hassubmit.png" alt="" />
      <div v-if="creatime">提交时间：{{creatime.slice(0,10)}}</div>
      <p>择校信息已提交，将在5个工作日内联系,请您耐心等待</p>
    </div>
  </div>
</template>
<script>
import { whatEev } from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';

export default {
  data() {
    return {
      creatime:this.$route.query.timeSubmit,
      isMiniProgram: false,

    };
  },
  components: {
    CommonTitle,
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.schoolChoose {
  height: 100%;
  background-color: #f7f8fc;
  padding-top: 430px;
  .submit {
    div {
      font-size: 25px;
      font-weight: 400;
      color: #999999;
      text-align: center;
      margin:13px auto 20px;
    }
    img {
      display: block;
      width: 340px;
      height: 242px;
      margin: 0 auto;
    }
    p {
      width: 450px;
      font-size: 25px;
      font-weight: 400;
      color: #333333;
      text-align: center;
      margin-bottom: 10px;
      margin:0 auto;
      line-height: 40px;
    }
  }
}
.inApp {
  padding-top: 330px;
}
</style>
